import {twMerge} from '@sdox/utils'

import {Headline, LazyImage, Tooltip} from '../..'

import type {ComponentProps} from 'react'

export interface CarSummaryProps extends ComponentProps<'div'> {
  title: string
  image: string | null
  subline?: string
  available: boolean
  reserved: boolean
}

const tooltipData = {
  none: {
    title: 'Fahrzeug noch verfügbar',
    color: 'bg-green-500',
  },
  reserved: {
    title: 'Fahrzeug ist reserviert',
    color: 'bg-orange-500',
  },
  available: {
    title: 'Fahrzeug nicht mehr verfügbar',
    color: 'bg-red-500',
  },
}

type TooltipDataKeys = keyof typeof tooltipData

export const CarSummary = ({
  title,
  subline,
  className,
  image,
  available,
  reserved,
  children,
  ...restProps
}: CarSummaryProps) => {
  let tooltipState: TooltipDataKeys = 'none'
  if (reserved) tooltipState = 'reserved'
  if (available) tooltipState = 'available'

  return (
    <div
      className={twMerge('flex items-center gap-4 bg-gray-50 p-4', className)}
      {...restProps}
    >
      <div className={'w-24 shrink-0 sm:block sm:w-36'}>
        <LazyImage
          src={image}
          alt={'car'}
          className={'select-none'}
        />
      </div>
      <div className={'flex w-full min-w-0 items-center justify-between gap-8'}>
        <div className={'min-w-0'}>
          <Headline
            size={4}
            tag={'h3'}
            className={'truncate'}
          >
            {title}
          </Headline>
          {subline && <p className={'mt-1 text-sm'}>{subline}</p>}
        </div>
        <div className={'ml-auto flex shrink-0 flex-wrap gap-2'}>
          {children}
          <Tooltip title={tooltipData[tooltipState].title}>
            <div className={twMerge('size-6 rounded-full', tooltipData[tooltipState].color)} />
          </Tooltip>
        </div>
      </div>
    </div>
  )
}
